import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, PenToolIcon } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Notary Services',
    href: '#services'
  }, {
    name: 'Why Choose a Notary',
    href: '#about'
  }, {
    name: 'Fresno Directory',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/80 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-127">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <div className="flex justify-between items-center" data-id="element-129">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group" data-id="element-130">
            <div className="bg-blue-900 text-white p-2 rounded-lg group-hover:bg-blue-800 transition-colors" data-id="element-131">
              <PenToolIcon className="w-5 h-5" data-id="element-132" />
            </div>
            <span className="text-xl font-bold text-slate-900 tracking-tight" data-id="element-133">
              Valley Notary <span className="text-blue-600" data-id="element-134">Pro</span>
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-135">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors" data-id="element-136">
                {link.name}
              </a>)}
            <a href="#contact" className="bg-blue-900 hover:bg-blue-800 text-white px-5 py-2.5 rounded-full text-sm font-medium transition-all hover:shadow-lg hover:-translate-y-0.5" data-id="element-137">
              View Resources
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 text-slate-600" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-138">
            {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-139" /> : <MenuIcon className="w-6 h-6" data-id="element-140" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-slate-100 shadow-lg py-4 px-4 flex flex-col gap-4" data-id="element-141">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-slate-700 p-2 hover:bg-slate-50 rounded-lg" onClick={() => setMobileMenuOpen(false)} data-id="element-142">
              {link.name}
            </a>)}
          <a href="#contact" className="bg-blue-900 text-white text-center px-5 py-3 rounded-lg text-base font-medium mt-2" onClick={() => setMobileMenuOpen(false)} data-id="element-143">
            View Resources
          </a>
        </div>}
    </header>;
}